export default class Toast {
    [x: string]: any; 
 	 static $inject = ['toaster','$translate'];
    constructor(toaster, $translate) {
        this.toaster = toaster;
        this.$translate = $translate;
    }

    error(code) {
        if (Array.isArray(code)) code.forEach((e) => this.display('ERROR', e));
        else this.display('ERROR', code ? code : 'ERROR_FETCHING');
    }

    success(code) {
        this.display('SUCCESS', code ? code : "SUCCESS_MSG");
    }

    warning(code, title) {
        this.display("WARNING", code, title);
    }

    display(type, code, title = null) {
        this.toaster.pop(type.toLowerCase(), this.$translate.instant(title ? title : type), this.$translate.instant(code));
    }
}
